import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { ConsultaItemRow, ConsultaDetalhamentoParcialRow, ConsultaRow } from 'src/modules/serasa/serasa.pf.types'

const consultaItemColumns = static_build_consulta_item_columns()
const detParcialColumns = static_build_det_parcial_columns()

export type ConsultasProps = {
    consulta: ConsultaRow
}

export default function Consultas({ consulta }: ConsultasProps) {
    if (!consulta || (!consulta.items && !consulta.cheque && !consulta.credito)) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Consulta</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <Grid item xs={12}>
                    <DataGrid
                        rows={consulta.items || []}
                        columns={consultaItemColumns}
                        getRowId={static_getConsultaItemRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Divider textAlign="center">Consulta de Cheques</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Total" value={consulta.cheque?.total?.toFixed(2)} xs={12} />

                <Grid item xs={12}>
                    <DataGrid
                        rows={consulta.cheque?.detalhamento_parcial || []}
                        columns={detParcialColumns}
                        getRowId={static_getDetalhamentoParcialRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Divider textAlign="center">Consulta de Crédito</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Total" value={consulta.credito?.total.toFixed(2)} xs={12} />

                <Grid item xs={12}>
                    <DataGrid
                        rows={consulta.credito?.detalhamento_parcial || []}
                        columns={detParcialColumns}
                        getRowId={static_getDetalhamentoParcialRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}

function static_getConsultaItemRowId(row: ConsultaItemRow) {
    return row.data + row.modalidade + row.origem
}

function static_getDetalhamentoParcialRowId(row: ConsultaDetalhamentoParcialRow) {
    return row.mes
}

function static_build_consulta_item_columns(): GridColDef[] {
    return [
        {
            field: 'data',
            headerName: 'Data',
            valueGetter(params) {
                return formatDate(params.row.data, 'dd/MM/yyyy HH:mm')
            },
            width: 100
        },
        {
            field: 'origem',
            headerName: 'Origem',
            width: 200
        },
        {
            field: 'modalidade',
            headerName: 'Modalidade',
            width: 200
        },
        {
            field: 'valor',
            headerName: 'Valor',
            width: 100
        }
    ]
}

function static_build_det_parcial_columns(): GridColDef[] {
    return [
        {
            field: 'mes',
            headerName: 'Mês',
            width: 200
        },
        {
            field: 'quantidade',
            headerName: 'Quantidade',
            width: 100
        }
    ]
}
